import { api } from "shared/config/api/api";
import { DEFAULT_PER_PAGE, getNextPage } from "shared/utils";
import type {
  NotificationsFilter,
  NotificationsPage,
  UnreadCount,
} from "../model/types";

export const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.infiniteQuery<
      NotificationsPage,
      NotificationsFilter,
      number
    >({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage) => getNextPage(lastPage),
      },
      query: ({ queryArg, pageParam }) => ({
        url: "/users/notifications",
        params: { ...queryArg, page: pageParam, per_page: DEFAULT_PER_PAGE },
      }),
      providesTags: ["Notifications"],
    }),
    getUnreadCount: builder.query<UnreadCount, void>({
      query: () => "/users/notifications/unread-count",
      providesTags: ["Notifications"],
    }),
  }),
});

export const { useGetNotificationsInfiniteQuery, useGetUnreadCountQuery } =
  notificationsApi;
